import cn from 'clsx';
import { forwardRef, HTMLAttributes, memo, useContext } from 'react';

import GuideContext from '../context';

import s from './GuideTextArea.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  titleType?: 'small' | 'medium' | 'large';
}

const GuideTextArea = forwardRef<HTMLDivElement, Props>(({ titleType = 'medium', children, className, ...props }, ref) => {
  const { isCard } = useContext(GuideContext);
  return (
    <div className={cn(s['text-area'], isCard && s['text-area__isCard'], className)} ref={ref} {...props}>
      {children}
    </div>
  );
});

const MemoGuideTextArea = memo(GuideTextArea);
export default MemoGuideTextArea;
